export default "__VITE_ASSET__Aoh_ELUG__"